import React from 'react';
import { Button, SelectPicker, Checkbox } from 'rsuite';

const ScheduleTypeForm = ({ 
    selectedSchedules, 
    scheduleTypes, 
    onAddScheduleType, 
    onRemoveScheduleType, 
    onUpdateScheduleType 
}) => {
    return (
        <div style={{ marginBottom: 20 }}>
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center', 
                marginBottom: '10px' 
            }}>
                <label style={{ fontWeight: 'bold' }}>班別設定：</label>
                <Button size="sm" appearance="primary" onClick={onAddScheduleType}>
                    + 新增班別
                </Button>
            </div>
            
            {selectedSchedules.length === 0 && (
                <div style={{ 
                    textAlign: 'center', 
                    padding: '20px', 
                    backgroundColor: '#f8f9fa', 
                    borderRadius: '4px' 
                }}>
                    <p style={{ color: '#6c757d', margin: 0 }}>
                        請點擊「新增班別」來設定班別
                    </p>
                </div>
            )}
            
            {selectedSchedules.map((schedule, index) => (
                <div 
                    key={schedule.id} 
                    style={{ 
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '15px',
                        marginBottom: '10px',
                        backgroundColor: '#fff'
                    }}
                >
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        marginBottom: '10px' 
                    }}>
                        <h6 style={{ margin: 0 }}>班別 {index + 1}</h6>
                        <Button 
                            size="xs" 
                            color="red" 
                            appearance="subtle" 
                            onClick={() => onRemoveScheduleType(schedule.id)}
                        >
                            移除
                        </Button>
                    </div>
                    
                            <div style={{ 
                                display: 'grid', 
                                gridTemplateColumns: '2fr 1fr', 
                                gap: '15px',
                                alignItems: 'center',
                                marginBottom: '10px'
                            }}>
                                <div>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '5px', 
                                        fontSize: '12px' 
                                    }}>
                                        班別類型：
                                    </label>
                                    <SelectPicker
                                        data={scheduleTypes.map(type => {
                                            const timeRange = type.start_time && type.end_time 
                                                ? `${type.start_time.substring(0, 5)}-${type.end_time.substring(0, 5)}`
                                                : '';
                                            const dayTypeLabel = type.day_type === 'rest_day' ? ' [休息日]' 
                                                : type.day_type === 'regular_holiday' ? ' [例假日]' 
                                                : '';
                                            return {
                                                label: `${type.name}${dayTypeLabel}${timeRange ? ` (${timeRange})` : ''}`, 
                                                value: parseInt(type.id) // 確保是數字
                                            };
                                        })}
                                        value={schedule.type_id}
                                        onChange={(value) => {
                                            // 只更新 type_id 就好，時間從 scheduleTypes 直接取得用於顯示
                                            onUpdateScheduleType(schedule.id, 'type_id', value);
                                        }}
                                        placeholder="選擇班別"
                                        cleanable={false}
                                        block
                                        searchable={false}
                                    />
                                </div>
                                
                                <div>
                                    <label style={{ 
                                        display: 'block', 
                                        marginBottom: '5px', 
                                        fontSize: '12px' 
                                    }}>
                                        時間：
                                    </label>
                                    <div style={{ 
                                        padding: '8px 12px',
                                        border: '1px solid #e5e5e5',
                                        borderRadius: '4px',
                                        backgroundColor: '#f8f9fa',
                                        fontSize: '14px',
                                        color: '#495057',
                                        textAlign: 'center'
                                    }}>
                                        {(() => {
                                            const selectedType = scheduleTypes.find(t => parseInt(t.id) === schedule.type_id);
                                            if (selectedType && selectedType.start_time && selectedType.end_time) {
                                                const startTime = selectedType.start_time.substring(0, 5);
                                                const endTime = selectedType.end_time.substring(0, 5);
                                                return `${startTime} - ${endTime}`;
                                            }
                                            return '請選擇班別';
                                        })()}
                                    </div>
                                </div>
                            </div>
                            
                            <div>
                                <Checkbox
                                    checked={schedule.is_national_holiday || false}
                                    onChange={(value, checked) => {
                                        onUpdateScheduleType(schedule.id, 'is_national_holiday', checked);
                                    }}
                                >
                                    <span style={{ fontSize: '12px' }}>國定假日上班</span>
                                </Checkbox>
                                <small style={{ 
                                    display: 'block', 
                                    marginTop: '5px', 
                                    color: '#6c757d',
                                    fontSize: '11px'
                                }}>
                                    勾選此選項表示該日期為國定假日，但員工需要上班
                                </small>
                            </div>
                </div>
            ))}
        </div>
    );
};

export default ScheduleTypeForm;
